import { getSession } from './index.js';

const DEFAULT_LOCALE = window.navigator.language || 'en_US';

export default function getLocale () {
  return getSession()
    .then(session => session.locale || DEFAULT_LOCALE);
}
